import BaseBusinessAPI from '../portal/baseBusinessAPI'

class PostAPI extends BaseBusinessAPI {
  controllerName = 'Posts';

  /**
   * @description Lấy danh sách thông báo của một trường
   * @param {*} payload
   * @returns
   */
  getListEnrollmentPost (payload) {
    const request = {
      url: this.getAPIUrl('list'),
      data: payload,
    }
    return this.getAsync(request)
  }

  /**
   * @description Lấy chi tiết thông báo của một trường
   * @param {*} payload
   * @returns
   */
  getEnrollmentPostById (payload) {
    const request = {
      url: this.getAPIUrl('detail'),
      data: payload,
    }
    return this.getAsync(request)
  }
}

export default new PostAPI()
